<form [formGroup]="form" (submit)="submit()" data-testid="ltv-model">
    <h3>{{ 'mortgage.header.loan-to-value.modal' | apContent }}</h3>

    {{ 'mortgage.question.loan-to-value.modal' | apContent }}
    <ap-amount-input
        data-testid="ltv-mortgage-amount"
        [numberOfDecimals]="0"
        [formControl]="mortgageControl"
    ></ap-amount-input>

    <h3>{{ 'purchase-price.header.loan-to-value.modal' | apContent }}</h3>
    {{ 'purchase-price.question.loan-to-value.modal' | apContent }}
    <ap-amount-input
        data-testid="ltv-purchase-price-amount"
        [numberOfDecimals]="0"
        [formControl]="purchasePriceControl"
    ></ap-amount-input>

    <ap-button type="submit" data-testid="submit">
        <ap-submit-text
            [isLoading]="isLoading"
            [loadingText]="'button-loading.loan-to-value.modal' | apContent"
            [submitText]="'button.loan-to-value.modal' | apContent"
        ></ap-submit-text>
    </ap-button>
</form>
